var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("emoji-invoker",null,{"events":{ click: function(e) { _vm.toggle(e); }}}),_vm._v(" "),(_vm.display.visible)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}]},[_vm._t("emoji-picker",null,{"emojis":_vm.emojis,"insert":_vm.insert,"display":_vm.display})],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }